<template>
  <v-app-bar class="main-header" height="64" fixed color="primary" dark>
    <v-btn icon class="mx-1" @click.stop="TOGGLE_DRAWER">
      <template v-if="DRAWER_STATE">
        <v-icon style="font-size: 28px">mdi-arrow-left</v-icon>
      </template>
      <template v-else>
        <v-icon style="font-size: 28px">mdi-menu</v-icon>
      </template>
    </v-btn>
    <v-toolbar-title>DIGIPATS</v-toolbar-title>
    <v-spacer></v-spacer>

    <!-- <v-menu offset-y bottom nudge-bottom="10" left>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          @click="
            notificationsBadge ? (notificationsBadge = !notificationsBadge) : ''
          "
          v-bind="attrs"
          v-on="on"
          style="font-size: 28px"
          icon
          class="mr-2"
        >
          <v-badge
            :value="notificationsBadge"
            color="error"
            content="4"
            overlap
          >
            <v-icon style="font-size: 28px" color="rgba(255, 255, 255, 0.35)"
              >mdi-bell-outline</v-icon
            >
          </v-badge>
        </v-btn>
      </template>
      <v-list>
        <v-list-item-group color="primary">
          <v-list-item v-for="(item, i) in notifications" :key="i">
            <v-list-item-icon class="mr-4 mb-1">
              <v-icon :color="item.color" v-text="item.icon"> </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="item.text"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-menu>
    <v-menu max-width="280" offset-y bottom nudge-bottom="10" left>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          @click="messageBadge ? (messageBadge = !messageBadge) : ''"
          v-bind="attrs"
          v-on="on"
          style="font-size: 28px"
          icon
          class="mr-2"
        >
          <v-badge :value="messageBadge" color="warning" content="3" overlap>
            <v-icon :color="config.light.iconColor" style="font-size: 28px">
              mdi-email-outline</v-icon
            >
          </v-badge>
        </v-btn>
      </template>
      <v-list>
        <div class="text-h5 grey--text text--darken-3 px-4 pt-4">
          New Messages
        </div>
        <div
          class="subtitle-2 error--text font-weight-regular px-4 pb-2 link-item"
        >
          4 new Messages
        </div>
        <v-list-item-group color="primary">
          <v-list-item v-for="(item, i) in messages" :key="i">
            <v-list-item-icon class="mr-4 mb-1 d-flex flex-column">
              <v-btn fab x-small depressed :color="item.color"
                >{{ item.text }}
              </v-btn>
              <div style="font-size: 11px">{{ item.time }}</div>
            </v-list-item-icon>
            <v-list-item two-line>
              <v-list-item-content style="width: 190px">
                <v-list-item-title
                  v-text="item.name"
                  class="pb-2"
                ></v-list-item-title>
                <v-list-item-subtitle
                  v-text="item.message"
                  class="text-truncate"
                ></v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list-item>
        </v-list-item-group>
        <div class="d-flex justify-center my-3">
          <v-btn
            large
            color="primary"
            rounded
            elevation="5"
            class="text-capitalize"
          >
            Send New Message
            <v-icon right dark>mdi-send</v-icon>
          </v-btn>
        </div>
      </v-list>
    </v-menu> -->
    <template-estado></template-estado>
    <v-menu max-width="280" offset-y bottom nudge-bottom="10" left>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          style="font-size: 28px"
          icon
          class="mr-2"
          @click="cambioClave()"
          title="Actualizar Contraseña"
        >
          <v-icon>mdi-key</v-icon>
        </v-btn>
      </template>
    </v-menu>
    <v-menu
      v-model="menuVisible"
      max-width="280"
      offset-y
      bottom
      nudge-bottom="10"
      left
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          @click="messageBadge ? (messageBadge = !messageBadge) : ''"
          v-bind="attrs"
          v-on="on"
          style="font-size: 28px"
          icon
          class="mr-2"
        >
          <v-icon :color="config.light.iconColor" style="font-size: 28px">
            mdi-cellphone-settings</v-icon
          >
        </v-btn>
      </template>
      <v-list>
        <div class="grey--text text--darken-3 px-4 pt-4">
          PROBAR NOTIFICACIÓN
        </div>
        <div class="d-flex justify-center my-3">
          <v-btn
            :loading="loading"
            color="primary"
            @click="notification"
            outlined
          >
            <v-icon center dark>mdi-send</v-icon>
          </v-btn>
        </div>
      </v-list>
    </v-menu>
    <v-menu min-width="180" offset-y bottom left nudge-bottom="10">
      <template v-slot:activator="{ on, attrs }">
        <v-btn class="mr-0" icon v-bind="attrs" v-on="on">
          <v-icon style="font-size: 28px" :color="config.light.iconColor"
            >mdi-account</v-icon
          >
        </v-btn>
      </template>
      <v-list>
        <div class="text-h5 grey--text text--darken-3 px-4 pt-4">
          {{ LOGUEADO }}
          <v-list-item-title class="text-h6 text-center">
            {{
              logueado.cargo ? logueado.cargo.toUpperCase() : ""
            }}</v-list-item-title
          >
        </div>
        <div class="d-flex justify-center my-3">
          <v-btn
            width="80%"
            large
            outlined
            color="primary"
            class="text-capitalize"
            @click="logOut"
            >Salir
          </v-btn>
        </div>
      </v-list>
    </v-menu>
    <modal-clave
      v-if="showModalClave"
      :showModal.sync="showModalClave"
      :id="id"
    ></modal-clave>
  </v-app-bar>
</template>

<script>
import { mapActions, mapState } from "vuex";

import config from "../../config";
// eslint-disable-next-line no-unused-vars
import Toast from "./Toast.vue";
import TemplateEstado from "./TemplateEstado.vue";
import ModalClave from "../../pages/Usuarios/ModalClave.vue";
import { db } from "@/firebase";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Header",
  components: {
    TemplateEstado,
    ModalClave,
  },
  data: () => ({
    config,
    searchCollapse: true,
    account: [
      {
        text: "Probar Notificación",
        icon: "mdi-send",
        color: "textColor",
      },
    ],
    notificationsBadge: true,
    messageBadge: true,
    loading: false,
    showModalClave: false,
    id: "",
    menuVisible: false,
  }),
  computed: {
    ...mapState(["drawer", "logueado"]),
    DRAWER_STATE: {
      get() {
        return this.drawer;
      },
    },
    LOGUEADO: {
      get() {
        return `${this.logueado.nombres} ${this.logueado.apellidos}`;
      },
    },
  },
  methods: {
    ...mapActions(["TOGGLE_DRAWER"]),
    async logOut() {
      await db.collection("usuarios").doc(this.logueado.id).update({
        login: false,
        disponibilidad: "Fuera de su horario laboral",
        token_login: "",
        salir: true,
        ip: "",
      });
      this.$store.commit("salir");
      this.$router.push("/login").catch(console.log);
    },
    async notification() {
      Notification.requestPermission().then(async (permission) => {
        if (permission === "granted") {
          this.loading = true;
          this.menuVisible = true;
          const to = localStorage.getItem("tokenPush") || "";
          const dominio =
            process.env.VUE_APP_AMBIENTE === "sandbox"
              ? "https://sandbox.digipats.com.co"
              : "https://digipats.com.co";
          const ambiente =
            process.env.VUE_APP_AMBIENTE === "sandbox"
              ? process.env.VUE_APP_CLOUDFUNCTIONURL_SANDBOX
              : process.env.VUE_APP_CLOUDFUNCTIONURL;
          const url = `${ambiente}/enviarNotificacionFcm`;

          const raw = JSON.stringify({
            tokens: [to],
            message: {
              notification: {
                title: "NOTIFICACIÓN",
                body: "TEST NOTIFICACIÓN DIGIPATS OK.",
              },
              data: {
                url: dominio,
              },
            },
          });

          try {
            const resultado = await fetch(url, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: raw,
              redirect: "follow",
            });

            if (!resultado.ok) {
              throw new Error("Error al enviar la notificacion");
            }
            this.loading = false;
            this.menuVisible = false;
          } catch (error) {
            this.$toast.warning(Toast, {
              position: "top-right",
              timeout: false,
              closeOnClick: false,
              pauseOnFocusLoss: true,
              pauseOnHover: true,
              draggable: true,
              draggablePercent: 0.6,
              showCloseButtonOnHover: false,
              hideProgressBar: true,
              closeButton: "button",
              icon: "fas fa-rocket",
              rtl: false,
            });
          }
        }
      });
    },
    cambioClave() {
      this.id = this.logueado.uiid;
      this.showModalClave = true;
    },
  },
};
</script>

<style src="./Header.scss" lang="scss"></style>
